import { createTheme } from '@mui/material';
import './App.css';
import { Layout } from './Components/Layout';
import RoutesComponent from './routes';
import Loader from './Components/UI/Loader';
import WithConditional from './Components/hoc/WithConditional';
import useLoaderStore from './store';

const theme = createTheme({
  palette: {
    primary: {
      main: "#002277",
    },
    secondary: {
      main: "#ffffff",
    },
  },
  typography: {
    fontFamily: 'Arial',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: 'Arial',
        },
      },
    },
  },

});

function App() {

  // useEffect(() => {
  //   if (userRole == 1) {
  //     navigate("/");
  //   } else if (userRole == 2) {
  //     navigate('/workbench', {
  //       state: {
  //         report: DUAL_ACCOUNT_REPORT
  //       }
  //     })
  //   }
  // }, []);
  const { loaderData, setLoaderData} = useLoaderStore();

  return (
    <div className="App">
       <WithConditional when={loaderData.display}>
        <Loader message={loaderData.message}/>
       </WithConditional>
       <Layout>
        <RoutesComponent />
       </Layout>
    </div>
  );
}

export default App;